import axios from './lib/axios';
import { forEach } from './lib/util';

function setLocale(languageKey) {
   const csrfMetaTag = document.querySelector('meta[name="csrf-token"]');
   axios({
      method: 'post',
      url: '/locale/switch',
      headers:
         // error pages don't have a csrf token; it's up to the API to refuse if needed
         csrfMetaTag ? { 'X-CSRF-TOKEN': csrfMetaTag.getAttribute('content') } : {},
      data: { selected: languageKey },
   })
      .then(function() {
         location.reload();
      })
      .catch(function() {
         console.warn('Could not change locale.');
      });
}

export function bindLocaleEvents() {
   forEach(document.querySelectorAll('#language-list li a'), el => {
      el.addEventListener('click', event => {
         setLocale(el.getAttribute('data-languageKey'));
         event.preventDefault();
      });
   });
}
